import { Answer, ExamPeriodState, QuestionType } from "@types";

export type ExamInstanceQuestion = {
    id: string;
    isLocked: boolean;
    text: string;
    points: number;
    answerState: ExamInstanceQuestionState;
    answers: Answer[];
    questionType: QuestionType;
    correctAnswerPoints: number;
    incorrectAnswerPoints: number;
    unansweredPoints: number;
    examInstanceState: ExamPeriodState;
}

export const enum ExamInstanceQuestionState {
    Unanswered = 0,
    Correct = 1,
    Incorrect = 2,
    RequiresManualGrading = 3
}